<template>
  <div>
    <div>
      <button v-if="!accountAddress" class="connect-wallet-btn" @click="connectWallet">
        Connect wallet
      </button>
      <button v-else class="connect-wallet-btn">
        {{ truncate(accountAddress) }}
      </button>
      <!-- Restrict logout/change wallet because the address is mapped in the db -->
    </div>
  </div>
</template>

<script>
import { ajaxCallMixin } from '@/http/HttpCommon';
export default {
  name: 'WalletConnectWithSave',
  mixins: [ajaxCallMixin],
  props: ['email', 'cast_id'],
  computed: {
    accountAddress() {
      return this.$store.state.accountAddress;
    },
  },
  methods: {
    async connectWallet() {
      await this.$store.dispatch('connectWallet');
      const payload = {
        cast_id: this.cast_id,
        email: this.email.toLowerCase(),
        public_address: this.accountAddress.toLowerCase(),
      };
      this.$store
        .dispatch('auth/saveWalletAddress', payload)
        .then((res) => {
          this.$emit('wallet-email-linked', true);
        })
        .catch((err) => {
          console.log(err, 'met err');
          this.$vs.notify({
            title: this.$t('Login.notify.title'),
            text:
              err.response != null
                ? err.response.data.message
                : this.$t('Metamasklogin.notconnected'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
    truncate(addressString) {
      return addressString.slice(0, 12) + '...' + addressString.slice(38);
    },

  },
};
</script>

<style scoped>
*:not(i) {
  font-family: 'Rethink Sans' !important;
}

.connect-wallet-btn {
  width: 100%;
  margin-top: 10px;
  background-color: #D3CA57;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.connect-wallet-btn:hover {
  background-color: #ebe369;
}
</style>
